module.exports = __webpack_public_path__ + "static/media/energie.f46456b1.png";